import { useApp, useUi, useUiDispatch } from "@/app/AppContext";
import { isRespondentOnly } from "@/domain/permissions";
import { InterventionEditor } from "@/features/interventions/InterventionEditor";
import { useI18n } from "@/i18n/useI18n";
import { InterventionDetails } from "./InterventionDetails";

/** Content of the details panel next to the matrix. */
export function DetailsPanel() {
  const { t } = useI18n();
  const { user, data } = useApp();
  const { panel } = useUi();
  const dispatch = useUiDispatch();

  if (panel.kind === "none") return <div className="details-empty">{t("infoDefault")}</div>;
  if (panel.kind === "create") return <InterventionEditor key="create" item={null} />;

  const item = data.dataset.items.find((entry) => entry.id === panel.itemId);
  if (!item) return <div className="details-empty">{t("infoDefault")}</div>;
  if (panel.kind === "edit") return <InterventionEditor key={item.id} item={item} />;

  return (
    <InterventionDetails
      key={item.id}
      item={item}
      onClose={() => {
        dispatch({ type: "closePanel" });
        if (isRespondentOnly(user)) dispatch({ type: "setTab", tab: "list" });
      }}
    />
  );
}
